import React, { useState } from "react";
import { Lock } from "lucide-react";
import { useProfile } from "../../context/ProfileContext";

const Settings = () => {
  const { changePassword, deleteAccount } = useProfile();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false); // ✅ hide UI after delete

  // ✅ Handle password update
  const handlePasswordChange = async () => {
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const res = await changePassword(password, confirmPassword);
    if (res?.status === 200) {
      alert("Password updated successfully");
      setPassword("");
      setConfirmPassword("");
    } else {
      alert(res?.message || "Failed to change password");
    }
  };

  // ✅ Handle account deletion
  const handleDeleteAccount = async () => {
    const res = await deleteAccount();
    if (res?.status === 200) {      
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("auth_user");
      localStorage.removeItem("sub_id");
      localStorage.removeItem("sub_cart");
      localStorage.removeItem("cart");
       
      alert("Account deleted successfully");
    window.location.href = "/login";
      setIsDeleted(true); // 🔥 removes white card
    } else {
      alert(res?.message || "Failed to delete account");
    }
    setShowDeleteConfirm(false);
  };

  // ✅ If account deleted — remove white box and show message
  if (isDeleted) {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh] text-center">
        <h2 className="text-2xl font-semibold text-gray-700 mb-3">
          Account Deleted
        </h2>
        <p className="text-gray-500">
          Your account has been successfully removed.
        </p>
      </div>
    );
  }

  return (
    <>
      {/* Main Settings Card */}
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6 pb-4 space-y-4 relative z-10 mt-8">
        <h2 className="text-lg font-semibold text-gray-700 mb-2">
          Account Settings
        </h2>

        {/* Change Password */}
        <div className="border rounded-xl p-4">
          <label className="block text-sm font-medium text-gray-600 mb-4">
            Change Password
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <div className="flex items-center space-x-2 border-b border-gray-300 pb-2">
              <Lock className="text-gray-400 w-5 h-5" />
              <input
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full focus:outline-none text-gray-700"
              />
            </div>
            <div className="flex items-center space-x-2 border-b border-gray-300 pb-2">
              <Lock className="text-gray-400 w-5 h-5" />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full focus:outline-none text-gray-700"
              />
            </div>
          </div>

          <button
            onClick={handlePasswordChange}
            className="bg-green-500 hover:bg-green-600 text-white w-full py-2 rounded-lg"
          >
            Save
          </button>
        </div>

        {/* Delete Account */}
        <div className="text-center mt-3 mb-1">
          <button
            onClick={() => setShowDeleteConfirm(true)}
            className="text-red-500 font-medium hover:underline"
          >
            Delete Account
          </button>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-lg flex items-center justify-center z-50">
          <div className="bg-white w-[380px] sm:w-[400px] rounded-2xl shadow-lg p-8 text-center">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Are you sure you want to delete your account?
            </h2>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleDeleteAccount}
                className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg"
              >
                Yes
              </button>
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-2 rounded-lg"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
